import { render, staticRenderFns } from "./TicketSplashScreen.vue?vue&type=template&id=0e7fdf70&scoped=true&"
import script from "./TicketSplashScreen.vue?vue&type=script&lang=js&"
export * from "./TicketSplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./TicketSplashScreen.vue?vue&type=style&index=0&id=0e7fdf70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7fdf70",
  null
  
)

export default component.exports